export const generativeAiAppGroupIdCampaignQa = "/:app_group_id/generative_ai/campaign_qa";
